import React, { useContext } from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import editorContext from "../editorContext";
import MarkdownRender from "./markdownRender"

const Container = styled.div`
  width: 50%;
  height: 100%;
  padding: 13px;
  font-family: "Lato", sans-serif;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 1em;
  padding: 8px 0;
  border-bottom: 1px solid rgba(15, 15, 15, 0.3);
`;

const ResultArea = styled.div`
  width: 100%;
  overflow:hidden;
  border: none;
  font-size: 17px;
`;

export function Result(props) {
  const { markdownText } = useContext(editorContext);

  return (
    <Container>
      <Title>Preview</Title>
      <ResultArea className="markdown-body" id="markdown-body">
        <MarkdownRender source={markdownText}></MarkdownRender>
      </ResultArea>
    </Container>
  );
}